import ViewaAnalytics from './core/ViewaAnalytics';

export * from './types';

export default ViewaAnalytics;
